import React from 'react';

const ProgressIndicator = ({ progress, answeredCount, totalQuestions }) => {
  return (
    <div className="progress-indicator">
      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="progress-text">
        <span>{answeredCount}</span> / <span>{totalQuestions}</span> kérdés megválaszolva
      </div>
    </div>
  );
};

export default ProgressIndicator;